import { Formik } from "formik";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { hard_delete_shop_record } from "../../services/migration.services";
import { validationHardDelete } from "../Shop/Shop.validation";
import CleanDataBaseForm from "./Forms/CleanDataBaseForm";

const initialState = {
  username: "",
  admin_email: "",
  admin_password: "",
};

const HardDelete = (props: any) => {
  const [loading, setLoading] = useState(false);
  const handleStepSubmit = async (value: any) => {
    setLoading(true);
    const data: any = {
      name: value?.username,
      email: value?.admin_email,
      password: value?.admin_password,
    };
    await hard_delete_shop_record(data)
      .then((res: any) => {
        setLoading(false);
        if (res?.data?.status == 200) {
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        toast.error(err.message);
      });
  };
  return (
    <Formik
      onSubmit={async (values, { resetForm }) => {
        await handleStepSubmit(values);
        setLoading(false);
        resetForm();
      }}
      enableReinitialize={true}
      initialValues={initialState}
      validate={(values) => {
        return validationHardDelete(values);
      }}
    >
      {({
        handleSubmit,
        values,
        handleChange,
        errors,
        setFieldValue,
        touched,
      }) => (
        <>
          <form onSubmit={handleSubmit}>
            <div className="content-box">
              <div className="content-body">
                <div>
                  <CleanDataBaseForm
                    handleChange={handleChange}
                    errors={errors}
                    values={values}
                    touched={touched}
                  />
                  <div className="px-2 py-4 d-flex justify-content-center">
                    <button
                      disabled={loading}
                      className="btn btn-primary primary-out"
                      type="submit"
                    >
                      Delete Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default HardDelete;
